var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMouseLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6582_12486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 26.4676C11.8802 26.4676 8.52686 23.3276 8.52686 19.4609V12.4676C8.52686 8.6076 11.8802 5.46094 16.0002 5.46094C20.1202 5.46094 23.4735 8.60094 23.4735 12.4676V19.4609C23.4735 23.3209 20.1202 26.4676 16.0002 26.4676ZM16.0002 6.93427C12.6869 6.93427 9.99352 9.42094 9.99352 12.4743V19.4676C9.99352 22.5209 12.6869 25.0076 16.0002 25.0076C19.3135 25.0076 22.0069 22.5209 22.0069 19.4676V12.4743C22.0069 9.42094 19.3135 6.93427 16.0002 6.93427Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7335 6.99414H15.2668V11.3275H16.7335V6.99414Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0069 15.2546C15.2869 15.2546 14.7002 14.6679 14.7002 13.9479V11.8946C14.7002 11.1746 15.2869 10.5879 16.0069 10.5879C16.7269 10.5879 17.3135 11.1746 17.3135 11.8946V13.9479C17.3135 14.6679 16.7269 15.2546 16.0069 15.2546Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6582_12486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMouseLight);
export default __webpack_public_path__ + "static/media/icon_mouse_light.46999e03.svg";
export { ForwardRef as ReactComponent };